"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
document.addEventListener('DOMContentLoaded', () => {
    const modalWindowDiv = document.querySelector('#strap-modal-window');
    if (modalWindowDiv) {
        const modalWindowClone = modalWindowDiv.cloneNode(true);
        modalWindowDiv.remove();
        document.body.appendChild(modalWindowClone);
    }
    const modalWindowDiplay = document.querySelector('#strap-modal-window');
    const closeModalWindow = document.querySelector('#close-strap-modal');
    if (closeModalWindow) {
        closeModalWindow.addEventListener('click', (e) => {
            e.preventDefault();
            modalWindowDiplay.style.display = 'none';
            document.body.style.overflowY = 'auto';
        });
    }
    const openModalWindow = document.querySelector('#open-strap-modal');
    if (openModalWindow) {
        openModalWindow.addEventListener('click', () => {
            modalWindowDiplay.style.display = 'block';
            document.body.style.overflowY = 'hidden';
        });
    }
    let selectedStrapProductId = null;
    const possibleStraps = document.querySelectorAll('#add-to-cart-strap');
    if (possibleStraps.length) {
        possibleStraps.forEach((productStrap) => {
            productStrap.addEventListener('click', (e) => {
                if (e.target) {
                    const eventValue = e.target;
                    let productId = eventValue.getAttribute('product-id');
                    if (!productId) {
                        const parentContainer = eventValue.closest('#add-to-cart-strap');
                        if (parentContainer) {
                            productId = parentContainer.getAttribute('product-id');
                        }
                        if (selectedStrapProductId) {
                            removeCurrentSelected(selectedStrapProductId);
                        }
                        parentContainer === null || parentContainer === void 0 ? void 0 : parentContainer.classList.add('active-strap');
                        selectedStrapProductId = productId;
                    }
                }
            });
        });
    }
    const addToCart = document.querySelector('#add-to-cart-strap-button');
    if (addToCart) {
        addToCart.addEventListener('click', (e) => __awaiter(void 0, void 0, void 0, function* () {
            const selectProduct = selectedStrapProductId;
            if (selectedStrapProductId) {
                removeCurrentSelected(selectedStrapProductId);
                selectedStrapProductId = null;
            }
            if (selectProduct) {
                const formData = new URLSearchParams();
                formData.append('quantity', '1');
                formData.append('form_type', 'product');
                formData.append('id', selectProduct);
                yield fetch('/cart/add.js', {
                    method: 'post',
                    body: formData
                });
                const getCart = yield fetch('/cart.js', {
                    method: 'get'
                });
                yield getCart.json();
                yield fetch('/cart?section_id=quick-cart', {
                    method: 'get'
                });
            }
            location.reload();
            e.preventDefault();
            modalWindowDiplay.style.display = 'none';
            document.body.style.overflowY = 'auto';
        }));
    }
});
function removeCurrentSelected(productID) {
    const previousElement = document.querySelector(`[product-id="${productID}"]`);
    if (previousElement) {
        previousElement.classList.remove('active-strap');
    }
}
